// extracted by mini-css-extract-plugin
export default {"root":"BlockMoneyCard_root__ochBH","media":"BlockMoneyCard_media__eOe-2","text":"BlockMoneyCard_text__MNOYd","moneyCard":"BlockMoneyCard_moneyCard__4uHKa"};